export default function TodayPaperManager() { return <div>আজকের পত্রিকা ম্যানেজমেন্ট</div>; }